/* istanbul ignore file */
import {Button} from '@homeaway/react-buttons';
import React from 'react';
import {withTranslationsAsProps} from '../../components/translations';
import './listing-pdp-button.less';

export function PdpButton({
    detailPageUrl,
    langLabel,
    onClick
}) {
    return (
        <Button
            className="listing-pdp-btn"
            href={detailPageUrl}
            label={langLabel}
            onClick={onClick}
            target="_blank"
        />
    );
}

export default withTranslationsAsProps({
    'tripboards.see.property-details': 'langLabel'
})(PdpButton);



// WEBPACK FOOTER //
// ./src/universal/tripboard/listing/listing-pdp-button.js